export const TOTAL_DAYS = 5;
export const MIN_TIME = 8;
export const MAX_TIME = 18;
